import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InventoryService } from 'src/app/ceq/inventory/inventory.service';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { EmployeeService } from 'src/app/ceq/catalog/employee/employee.service';
import { CarrierService } from '../carrier.service';
import { CarrierModel } from 'src/app/ceq/common/models/Carrier.Model';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { Employee } from 'src/app/ceq/common/models/Employee.Model';
import { Unit } from 'src/app/ceq/common/models/Unit.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-carrier-detail',
  templateUrl: './carrier-detail.component.html',
  styleUrls: ['./carrier-detail.component.scss']
})
export class CarrierDetailComponent implements OnInit {

  constructor(private url: ActivatedRoute,
    private settings: SettingsService,
    private carrierService: CarrierService,
    private employeeService: EmployeeService,
    private globalFunctionService: GlobalFunctionsService,
    private inventoryService: InventoryService) {
    this.carrier = new CarrierModel();
  }

  org: number = 1;
  userLogin: UserLogin;
  carrier: CarrierModel;
  vehicleId: number;
  isNew: boolean = false;
  units: Unit[] = [];
  employees: Employee[] = [];
  selectedUnit: string = "";
  selectedEmployee: string = "";
  searchEmployeeField = 'EmployeeName';
  searchUnitField = 'UnitDescription';

  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
    let currentId = this.url.snapshot.paramMap.get('id');
    this.carrier.Org = this.userLogin.Org;

    if (this.isNullOrWhitespace(currentId)) {
      this.isNew = true;
      this.fillCombos();
    }
    else {
      this.isNew = false;
      this.carrier.EmployeeCode = currentId;
      this.getFiscalConfig();
    }
  }

  formSubmit(value: any) {
    if (this.isNew) {
      //Create
      this.carrierService.createCarrier(this.carrier).subscribe(async data => {
		    await this.globalFunctionService.messageBimbo('Vehículo creada', 'success', '¡Éxito!');
        this.btnCancelOnClick();
      }, async (error) => {
        await this.globalFunctionService.messageBimbo( error.error, 'error', '¡Error!');
      });
    }
    else {
      //Update
      this.carrierService.updateCarrier(this.carrier).subscribe(async data => {
		    await this.globalFunctionService.messageBimbo('Vehículo actualizado', 'success', '¡Éxito!');
        this.btnCancelOnClick();
      }, async (error) => {
		    await this.globalFunctionService.messageBimbo( error.error, 'error', '¡Error!');
      });
    }
  }

  btnCancelOnClick() {
    // this.router.navigate(['/tax/carrier']);
    window.close();
  }

  changeEmployee(event: Employee): void {
    this.carrier.EmployeeCode = event.EmployeeCode;
    // this.getLabelFilters();
  }

  changeUnit(event: Unit): void {
    this.carrier.UnitId = event.UnitId;
    // this.getLabelFilters();
  }


  isNullOrWhitespace(input) {
    if (typeof input === 'undefined' || input == null) return true;
    return input.replace(/\s/g, '').length < 1;
  }

  fillCombos() {
    //Employees
    this.employeeService.GetEmployeesByUnitId(this.userLogin.UnitId, "", 0).subscribe(data => {
      this.employees = data;

      if (!this.isNew) {
        this.selectedEmployee = this.employees.find(x => x.EmployeeCode == this.carrier.EmployeeCode).EmployeeName;
      }
    });
    //Units
    this.inventoryService.getAllFactoryCeve().subscribe((data: Unit[]) => {
      this.units = data;

      if (this.isNew) {
        this.carrier.UnitId = this.userLogin.UnitId;
        this.selectedUnit = this.units.find(x => x.UnitId == this.userLogin.UnitId).UnitDescription;
      }
      else {
        this.selectedUnit = this.units.find(x => x.UnitId == this.carrier.UnitId).UnitDescription;
      }
    })
  }

  getFiscalConfig() {
    this.carrierService.getCarrierById(this.carrier.EmployeeCode).subscribe(data => {
      this.carrier = data;
      this.selectedEmployee = data.EmployeeCode;
      //obtengo los datos de los combos
      this.fillCombos();

    }, async (error) => {
		  await this.globalFunctionService.messageBimbo(  "No se encontró el vehículo solicitado", 'warning', '¡Alerta!');
      this.btnCancelOnClick();
    });
  }
}
